import Swal from "sweetalert2";
export const handleCouponDelete = async (couponId, {fetchData, setDeletingCouponId, cars, rentals, coupons, contact, drivers, tours, tourBookings, employeeService, setCarsData, setRentalsData, setCouponsData, setTransfersData, setDriversData, setToursData, setTourBookingsData, setEmployeesData, setSeasonalPricing, setIsLoading, setError}) => {
    try {
        setDeletingCouponId(couponId);
        await coupons.delete(couponId);
        fetchData();
    } catch (error) {
        console.error("Error deleting coupon:", error);
        await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to delete coupon. Please try again.",
        confirmButtonColor: "#1e3a8a",
        });
    } finally {
        setDeletingCouponId(null);
    }
};